export default "__VITE_PUBLIC_ASSET__3542a297__"